import React from 'react';
import AppLink from '../shared/AppLink';

const ActivitiesCard = ({ activity, className = "" }) => {
  const slugValue = typeof activity.slug === 'string'
    ? activity.slug
    : activity.slug?.current;
  const costLabel = activity.cost || '';
  const categoryLabel = activity.category || '';
  const areaLabel = activity.area || '';

  return (
    <div className={`flex flex-col h-full w-full min-w-0 max-w-[370px] mx-auto ${className}`}>
      <AppLink to={`/activities/${slugValue}`} className="block group h-full hover:text-green-300 transition-colors">
        <div className="border border-white/10 rounded-lg overflow-hidden">
          <div
            className="bg-white/5 p-3 flex items-center justify-center text-center"
            style={{
              height: '3.5em',
            }}
          >
            <h3 className="text-lg font-bold leading-tight">
              {activity.name}
            </h3>
          </div>
          
          <div className="bg-white/5 px-3 py-2 border-t border-white/10">
            <div className="grid grid-cols-[auto_minmax(0,1fr)_minmax(0,1fr)] items-center gap-2 text-sm whitespace-nowrap">
              <span className="min-w-0 truncate" title={costLabel}>{costLabel}</span>
              <span className="min-w-0 truncate text-center" title={categoryLabel}>{categoryLabel}</span>
              <span className="min-w-0 truncate text-right" title={areaLabel}>{areaLabel}</span>
            </div>
          </div>

          {activity.images?.[0]?.asset?.url && (
            <img
              src={activity.images[0].asset.url}
              alt={activity.name}
              className="w-full object-cover"
              style={{ aspectRatio: '5/3', maxHeight: 200 }}
              loading="lazy"
            />
          )}
          
          <div className="bg-white/5 p-3 border-t border-white/10" style={{ height: '11em' }}>
            <p className="text-sm leading-tight overflow-hidden">
              {activity.shortDescription}
            </p>
          </div>
        </div>
      </AppLink>
    </div>
  );
};

export default ActivitiesCard;
